import { render } from "./DocumentEditionPage.vue?vue&type=template&id=7caa6d0b&scoped=true"
import script from "./DocumentEditionPage.vue?vue&type=script&lang=js"
export * from "./DocumentEditionPage.vue?vue&type=script&lang=js"

import "./DocumentEditionPage.vue?vue&type=style&index=0&id=7caa6d0b&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7caa6d0b"]])

export default __exports__